'use strict';

const round = (value, mantissa = 4) => Math.round(value * Math.pow(10, mantissa)) / Math.pow(10, mantissa);

module.exports.round = round;
